import React from 'react'
import {Route, Redirect} from 'react-router'
import asyncComponent from '../../core/components/async-component/AsyncComponent'

const AsyncDashboard = asyncComponent({
  loader: () => import('./components/Dashboard'),
  modules: ['./components/Dashboard'],
  webpack: () => [require.resolveWeak('./components/Dashboard')]
})

const AsyncDashboardMenu = asyncComponent({
  loader: () => import('./components/DashboardMenu'),
  modules: ['./components/DashboardMenu'],
  webpack: () => [require.resolveWeak('./components/DashboardMenu')]
})

const AsyncProblemsDashboard = asyncComponent({
  loader: () => import('./components/ProblemsDashboard'),
  modules: ['./components/ProblemsDashboard'],
  webpack: () => [require.resolveWeak('./components/ProblemsDashboard')]
})


// The keys are required for rendering an array like this, but to us this
// serves no purpose.
const dashboardRoute = [
  <Route exact key='dashboard' path='/dashboard/:subject' component={AsyncDashboard} />,
  <Route exact key='dashboard-menu' path='/dashboard/' component={AsyncDashboardMenu} />,
  <Route exact key='dashboard-problems' path='/dashboard/:topicId/problems' component={AsyncProblemsDashboard} />,

]
export default dashboardRoute




// WEBPACK FOOTER //
// ./src/domains/dashboard_v3/index.js